import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { ExSwitch } from "../../../components/ExSwitch";
import { model_importancia_requisicao } from "../../../models";

export const Importancia = () => {
    const columns = [
        { field: 'impdescricao', header: 'Descrição' },
        { field: 'impsequencia', header: 'Sequência', style: { width: '125px' } },
        { field: 'impprioridade', header: 'Prioridade', body: (e: any) => <ExSwitch checked={e.impprioridade === 1} /> },
        { field: 'impvativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '2rem', width: '2rem' } }
    ];

    return (
        <ConsultaPadrao model={model_importancia_requisicao} columns={columns} sortField="impsequencia" />
    )
}